import { Box, domRectToBox } from './svgutil'
import { TWEEN, Tween, Easing } from './tween';


export class CoordsMemento {
    
    static seq = 1

    static valueOf($svg: JQuery<SVGSVGElement>) : CoordsMemento {
        let m = new CoordsMemento()
        $svg.find(".node").each((i, e) => {
            let node = e as unknown as SVGGraphicsElement
            let domRect = node.getBBox()
            let box = domRectToBox(domRect)
            //console.log("node " + node.id + " " + box.x + ", " + box.y + ", " + box.w + ", " + box.h)
            m.id2coords.set(node.id, box)
        })
        $svg.find(".edge").each((i, e) => {
            let edge = e as unknown as SVGGraphicsElement
            let domRect = edge.getBBox()
            let box = domRectToBox(domRect)
            m.id2coords.set(edge.id, box)
        })
        return m
    }

    static setEdgeOpacity($svg: JQuery<SVGSVGElement>, duration: number, opacity0: number, opacity1: number) {
        $svg.find(".edge").each((i, e) => {
            let svgedge = e as unknown as SVGElement
            if (duration == 0) {
                svgedge.style.opacity = opacity1.toString()
            } else {
                this.animateOpacity(svgedge, duration, opacity0, opacity1)
            }
        })
    }

    static setTranslations($svg: JQuery<SVGSVGElement>, duration_: number, from: CoordsMemento, to: CoordsMemento) {
        //console.log("setting translations: " + from + " -> " + to);
        let keys = Array.from(to.id2coords.keys())
        let svg = $svg.get(0)
        for (let key of keys) {
            let b0 = from.id2coords.get(key)
            let b1 = to.id2coords.get(key)
            let node = svg.querySelector("#" + key)
            if (b0 && b1) {
                //console.log("check (" + b0.x + ", " + b0.y + ")" + " vs (" + b1.x + ", " + b1.y + ")")
                let tx = b0.x - b1.x
                let ty = b0.y - b1.y
                //console.log("node " + node.id + " " + tx + ", " + ty)
                if (node) {
                    let svgnode = node as SVGElement
                    svgnode.setAttribute("transform", `translate(${tx},${ty})`)
                    if (tx != 0 || ty != 0) {
                        CoordsMemento.animateTranslation(svgnode, duration_, tx, ty, 0, 0)
                    }
                }
            } else if (!b0 && b1) {
                if (node) {
                    let svgnode = node as SVGElement
                    svgnode.removeAttribute("transform")
                    this.animateOpacity(svgnode, 250, 0, 1)
                }
            }
        }
    }
    
    
    static animateOpacity(svgelement: SVGElement, duration: number, opacity0: number, opacity1: number) {
        let start = {
            t: 0,
            opacity: opacity0,
        }
        let end = {
            t: 1,
            opacity: opacity1,
        }
        let tween1 = new Tween(start, this.toString())
            .to(end, duration)
            .easing(Easing.Quadratic.InOut)
            .onUpdate((curr: any) => {
                svgelement.style.opacity = curr.opacity.toString()
            })
            .onComplete((curr: any) => {
                svgelement.style.opacity = curr.opacity.toString()
            });
        tween1.start()
    }

    static animateTranslation(svgelement: SVGElement, duration: number, x0: number, y0: number, x1: number, y1: number) {
        let start = {
            t: 0,
            x: x0,
            y: y0,
        }
        let end = {
            t: 1,
            x: x1,
            y: y1,
        }
        let tween1 = new Tween(start, this.toString())
            .to(end, duration)
            .easing(Easing.Quadratic.InOut)
            .onUpdate((curr: any) => {
                svgelement.setAttribute("transform", `translate(${curr.x},${curr.y})`)
            })
            .onComplete((curr: any) => {
                svgelement.setAttribute("transform", `translate(${curr.x},${curr.y})`)
                //TWEEN.remove(tween1)
            });
        tween1.start()
    }


    id2coords = new Map<string,Box>()
    seq = 0

    private constructor() {
        this.seq = CoordsMemento.seq++
    }

    toString() {
        return `CoordsMemento [ seq=${this.seq}, count=${this.id2coords.size} ]`
    }

    
    
}